import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} - Talox Games`;
    } else {
      document.title = `Talox Games — Elder House`;
    }
  }, [title]);
};
